declare global {
  interface Window {
    dataLayer?: object[];
  }
}

export interface DownloadResourceEvent {
  resourceIds: number[];
  imagesPerDownload: number;
}

export interface DownloadCollectionEvent {
  collectionId: number;
  imagesPerDownload: number;
}

export const postAnalyticsEvent = (
  eventName: string,
  params: DownloadResourceEvent | DownloadCollectionEvent
) => {
  if (window.dataLayer) {1
    window.dataLayer.push({
      event: eventName,
      ...params,
    });
  }
};
